import { FriendlyError, ResponsiveDialog } from '@cibo/ui'
import { LoadingButton } from '@mui/lab'
import { Button, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material'
import { pluck } from 'ramda'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useUpdateProgramEngagement } from '../../../../../queries'
import { ConfirmIneligibleDialogProps } from '../ConfirmIneligibleDialogTypes'
import { FieldReasonsTable } from '../FieldReasonsTable/FieldReasonsTable'

export const ConfirmIneligibleFieldsDialog = ({
  engagementId,
  onClose,
  onConfirm,
  open,
  reasons,
}: ConfirmIneligibleDialogProps) => {
  const { t } = useTranslation('@cibo/programs/ConfirmIneligibleFieldsDialog')

  const { mutateAsync: updateEngagement, isLoading, error, reset } = useUpdateProgramEngagement()
  useEffect(reset, [open])
  const resourceIds = reasons && (pluck('id', reasons) as string[])

  const handleConfirm = () => {
    if (engagementId && resourceIds) {
      updateEngagement({ id: engagementId, action: 'remove', fields: resourceIds }).then(onConfirm)
    }
  }

  return (
    <ResponsiveDialog maxWidth="sm" open={open} onClose={onClose} fullWidth>
      <DialogTitle sx={{ minWidth: 384 }}>{t('title', { count: resourceIds?.length })}</DialogTitle>

      <DialogContent>
        <Typography>{t('wishToMoveForward', { count: resourceIds?.length })}</Typography>

        <FieldReasonsTable reasons={reasons} />

        {!!error && <FriendlyError message={t('errorRemovingFields')} />}
      </DialogContent>

      <DialogActions>
        <Button color="secondary" disabled={isLoading} onClick={onClose}>
          {t('keepEditing', { ns: '@cibo/programs/ConfirmIneligibleDialog' })}
        </Button>
        <LoadingButton variant="contained" loading={isLoading} onClick={handleConfirm}>
          {t('confirm', { ns: '@cibo/programs/ConfirmIneligibleDialog' })}
        </LoadingButton>
      </DialogActions>
    </ResponsiveDialog>
  )
}
